import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useState } from "react";

import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function MainLayout() {
    const [mobileOpen, setMobileOpen] = useState(false);

    const toggleSidebar = () => {
        setMobileOpen((prev) => !prev);
    };

    return (
        <Box
            sx={{
                display: "flex",
                height: "100vh",
                width: "100%",
                backgroundColor: "background.default",
                overflow: "hidden",
                "@supports (height: 100dvh)": {
                    height: "100dvh",
                },
            }}
        >
            {/* SIDEBAR */}
            <Sidebar
                mobileOpen={mobileOpen}
                setMobileOpen={setMobileOpen}
            />

            {/* RIGHT SIDE */}
            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    minWidth: 0,


                }}
            >
                {/* TOPBAR */}
                <Topbar
                    mobileOpen={mobileOpen}
                    toggleSidebar={toggleSidebar}
                />

                {/* CONTENT */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        overflow: "auto",
                        px: { xs: 0.5, sm: 1, md: 1.5 },
                        py: { xs: 1, md: 1.5 },
                        mt: { xs: "60px", md: "68px" },
                        minWidth: 0,
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
}
